import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Lock, Loader2, ArrowRight } from "lucide-react";
import { toast } from "sonner";
import { api, setAdminToken } from "../../api";
import { BrandMark } from "../../components/Brand";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("admin@qrtourist.com");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    try {
      const r = await api.adminLogin(email, password);
      setAdminToken(r.token);
      toast.success("Login effettuato");
      navigate("/admin/dashboard");
    } catch (err) {
      toast.error("Login fallito", { description: err?.message || "Credenziali non valide" });
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="min-h-screen bg-bg flex items-center justify-center px-5 page-enter">
      <div className="w-full max-w-md bg-white border border-border rounded-3xl p-8 shadow-xl">
        <div className="flex items-center gap-3 mb-6">
          <BrandMark />
          <div>
            <div className="font-heading font-bold text-xl text-ink">QrTourist Admin</div>
            <div className="text-xs text-ink-soft">Dashboard di gestione</div>
          </div>
        </div>

        <h1 className="font-heading font-bold text-3xl text-ink mt-2">Accedi</h1>
        <p className="text-sm text-ink-soft mt-1 mb-6">Gestisci musei, opere e statistiche.</p>

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="text-xs font-semibold text-ink-soft tracking-wider">EMAIL</label>
            <input
              data-testid="admin-login-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="w-full mt-1.5 px-4 py-3 bg-bg border border-border rounded-xl text-ink focus:outline-none focus:border-brand transition"
              placeholder="admin@qrtourist.com"
            />
          </div>
          <div>
            <label className="text-xs font-semibold text-ink-soft tracking-wider">PASSWORD</label>
            <input
              data-testid="admin-login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              className="w-full mt-1.5 px-4 py-3 bg-bg border border-border rounded-xl text-ink focus:outline-none focus:border-brand transition"
              placeholder="••••••••"
            />
          </div>
          <button
            data-testid="admin-login-submit"
            type="submit"
            disabled={busy}
            className="w-full inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-hover text-white py-3.5 rounded-xl font-semibold disabled:opacity-60 transition"
          >
            {busy ? <Loader2 className="animate-spin" /> : (<>Accedi <ArrowRight size={18} /></>)}
          </button>
        </form>

        <div className="flex items-center gap-2 mt-6 text-xs text-ink-soft">
          <Lock size={12} />
          <span>Sessione protetta JWT · 24h</span>
        </div>
      </div>
    </div>
  );
}
